import { Component, OnInit } from '@angular/core';
import { PopupComponent } from '../../popup.component';

@Component({
    selector: 'ez-popup-blacklist-unlock',
    template: require('./popup-blacklist-unlock.component.html'),
})
export class BlacklistUnlockPopupComponent extends PopupComponent implements OnInit {
    private sentence: string = '';

    public ngOnInit() {
        if (this.popupService.hasData('sentence')) {
            this.sentence = this.popupService.getData('sentence');
        }
    }

    public accept() {
        this.sendResult({
            result: true
        });
    }

    public refuse() {
        this.sendResult({
            result: false
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/popup/types/blacklistUnlock/popup-blacklist-unlock.component.ts